module.exports = __webpack_public_path__ + "af7541a7af6673c7378cfe1a31e856bf.mp4";